import DetailClient from '@/views/client/DetailClient.vue'
import ClientDetailTabInfo from '@/components/client/DetailTabClient.vue'
import demandRouter from '@/router/routers/client/detail/demand'
import timelineRouter from '@/router/routers/client/detail/timeline'
import workedHourRouter from '@/router/routers/client/detail/workedHour'
import brandRouter from '@/router/routers/client/detail/brand'
import contractRouter from '@/router/routers/client/detail/contract'
import corporateRouter from '@/router/routers/client/detail/corporate'
import collaboratorRouter from '@/router/routers/client/detail/collaborator'
import FormStaff from '@/views/client/staff/FormStaff'

const detailRouter = (beforeEnter, name, singleName, basePath, tabs, onlyManaged, options) => {
    return [
        {
            beforeEnter: beforeEnter,
            name: '',
            path: `/${basePath}/detalhe/:id`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                layout: 'default'
            },
            props: true,
            component: DetailClient,
            children: [
                {
                    beforeEnter: beforeEnter,
                    name: `${name}DetalheAbaInfo`,
                    path: '',
                    meta: {
                        requiresAuth: true,
                        isEmployee: true,
                        layout: 'default',
                        basePath: basePath,
                        singleName: singleName,
                        tabs
                    },
                    props: true,
                    component: ClientDetailTabInfo
                },
                demandRouter(beforeEnter, name, singleName, basePath, tabs),
                timelineRouter(beforeEnter, name, singleName, basePath, tabs),
                workedHourRouter(beforeEnter, name, singleName, basePath, tabs),
                brandRouter(beforeEnter, name, singleName, basePath, tabs),
                contractRouter(beforeEnter, name, singleName, basePath, tabs),
                corporateRouter(beforeEnter, name, singleName, basePath, tabs),
                collaboratorRouter(beforeEnter, name, singleName, basePath, tabs)
            ]
        },
        {
            beforeEnter: beforeEnter,
            name: `${singleName}DetalheAbaUsuarioCadastrar`,
            path: `/${basePath}/detalhe/:requesterType/equipe/cadastrar`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                layout: 'default'
            },
            props: true,
            component: FormStaff
        },
        {
            beforeEnter: beforeEnter,
            name: `${singleName}DetalheAbaUsuarioEditar`,
            path: `/${basePath}/detalhe/:requesterType/equipe/editar/:id`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                layout: 'default'
            },
            props: true,
            component: FormStaff
        }
    ]
}

export default detailRouter
